import React, { useEffect } from "react";

import gsap from "gsap";

import "./index.scss";

import BackCloseButton from "components/BackCloseButton";

import background from "assets/background/background-datail-cocktail.webp";
import qrCode from "assets/qr.png";
import DrinkResponsibly from "../../components/DrinkResponsibly";

const Signature = () => {
  useEffect(() => {
    gsap
      .timeline()
      .to([".signature-video-container", ".signature-content *"], {
        opacity: 0,
        duration: 0,
      })
      .to([".signature-video-container", ".signature-content *"], {
        opacity: 1,
        stagger: 0.1,
      });
  }, []);

  return (
    <div
      className="signature page"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <BackCloseButton navigationPath="/home" />

      <div className="signature-video-container col-7">
        <video
          className="signature-video"
          src={require("assets/video/home/signature.mp4")}
          poster={require("assets/video/home/poster/signature.webp")}
          autoPlay
          muted
          loop
        />
      </div>

      <div className="signature-content col-8">
        <div className="signature-content-title-container">
          <h1 className="heading-huge accent-underline">Negroni Croisette</h1>
          <p className="heading-5 col-6">
            An elegant and delicate Negroni characterized by the perfect balance
            between sea scent and the warmth of hazelnut ending in an unexpected
            touch of spice.
          </p>
        </div>

        <div className="signature-content-discover-container">
          <h3 className="heading-4">
            Discover now the signature cocktail uniquely designed by Campari
          </h3>

          <img
            className="signature-content-discover-qr-code"
            src={qrCode}
            alt="qr code"
            draggable={false}
          />

          <div className="signature-content-discover-bottom-container">
            <h2 className="heading-2">Scan the QR Code</h2>
            <h4 className="heading-4">
              and show it to our bartenders to get the chance to taste it.
            </h4>
          </div>
        </div>
      </div>

      <DrinkResponsibly />
    </div>
  );
};

export default Signature;
